"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHECK_EMPLOYEE_PAYMENT_METHOD_STATUS = exports.CHECK_EMPLOYEE_SSN_STATUS = exports.CHECK_COMPANY_PROVIDED_DOCUMENT_TYPES = exports.CHECK_BANK_ACCOUNT_STATUS = exports.CHECK_FEDERAL_EIN_NAME = exports.CHECK_FEDERAL_EIN_STATUS = exports.CHECK_INDUSTRY_TYPES = exports.CHECK_BUSINESS_TYPES = void 0;
exports.CHECK_BUSINESS_TYPES = [
    "sole_proprietorship",
    "partnership",
    "c_corporation",
    "s_corporation",
    "llc",
    "government_entity",
];
exports.CHECK_INDUSTRY_TYPES = [
    "auto_or_machine_sales",
    "auto_or_machine_repair",
    "arts_or_entertainment_or_recreation",
    "cleaning_services",
    "consulting_services",
    "educational_services",
    "family_care_services",
    "financial_services",
    "food_and_beverage_retail_or_wholesale",
    "general_construction_or_general_contracting",
    "government_or_public_administration",
    "health_care",
    "hospitality_or_accommodation",
    "hvac_or_plumbing_or_electrical_contracting",
    "legal_services",
    "non_food_retail_or_wholesale",
    "other",
    "personal_care_services",
    "real_estate",
    "restaurant",
    "scientific_or_technical_services",
    "security_services",
    "tobacco_or_alcohol_sales",
    "transportation",
];
exports.CHECK_FEDERAL_EIN_STATUS = [
    "processing",
    "completed",
    "failed",
    "not_initiated",
    "verified"
];
exports.CHECK_FEDERAL_EIN_NAME = "federal_ein";
exports.CHECK_BANK_ACCOUNT_STATUS = [
    "validation_pending",
    "validated",
    "ownership_verified",
    "disabled_recoverable",
    "disabled_irrecoverable"
];
exports.CHECK_COMPANY_PROVIDED_DOCUMENT_TYPES = [
    "940",
    "941",
    "943",
    "944",
    "945",
    "ss4",
    "cp_575",
    "147_c",
    "signatory_photo_id",
    "voided_check",
    "bank_statement",
    "bank_letter",
];
exports.CHECK_EMPLOYEE_SSN_STATUS = [
    "ssn_submitted",
    "ssn_validated",
];
exports.CHECK_EMPLOYEE_PAYMENT_METHOD_STATUS = [
    "payment_method_preference_set",
    "bank_account_exists",
    "bank_account_verified",
];
